/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 乗務員row
 * @export
 * @interface DriversMenuRow
 */
export interface DriversMenuRow {
    /**
     * 乗務員ID
     * @type {number}
     * @memberof DriversMenuRow
     */
    driverId?: number;
    /**
     * 乗務員番号
     * @type {string}
     * @memberof DriversMenuRow
     */
    driverCode?: string;
    /**
     * 乗務員名
     * @type {string}
     * @memberof DriversMenuRow
     */
    driverName?: string;
    /**
     * 営業所ID
     * @type {number}
     * @memberof DriversMenuRow
     */
    officeId?: number;
    /**
     * 営業所名称
     * @type {string}
     * @memberof DriversMenuRow
     */
    officeName?: string;
    /**
     * 契約種別
     * @type {string}
     * @memberof DriversMenuRow
     */
    planType?: string;
    /**
     * 退職者フラグ
     * @type {boolean}
     * @memberof DriversMenuRow
     */
    isRetired?: boolean;
}

export function DriversMenuRowFromJSON(json: any): DriversMenuRow {
    return DriversMenuRowFromJSONTyped(json, false);
}

export function DriversMenuRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): DriversMenuRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'driverId': !exists(json, 'driver_id') ? undefined : json['driver_id'],
        'driverCode': !exists(json, 'driver_code') ? undefined : json['driver_code'],
        'driverName': !exists(json, 'driver_name') ? undefined : json['driver_name'],
        'officeId': !exists(json, 'office_id') ? undefined : json['office_id'],
        'officeName': !exists(json, 'office_name') ? undefined : json['office_name'],
        'planType': !exists(json, 'plan_type') ? undefined : json['plan_type'],
        'isRetired': !exists(json, 'is_retired') ? undefined : json['is_retired'],
    };
}

export function DriversMenuRowToJSON(value?: DriversMenuRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'driver_id': value.driverId,
        'driver_code': value.driverCode,
        'driver_name': value.driverName,
        'office_id': value.officeId,
        'office_name': value.officeName,
        'plan_type': value.planType,
        'is_retired': value.isRetired,
    };
}


